import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../../services/auth.service";
import { Router } from '@angular/router';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { getPasswordSegurity } from 'src/app/src/utl';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public loading = false;
  public currentYear;
  
  constructor(private _loginService : AuthService, private router : Router, private permissions:PermissionsService, private toastr: ToastrManager ) { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    if(this._loginService.isAuthenticated()) {
      this.router.navigate(['/principal']);
    }
  }

  async login(event){
    event.preventDefault();
    
    var username:string = event.target.querySelector('#username').value;
    var password:string = event.target.querySelector('#password').value;

    this.loading = true;
    try {
      let token = await this._loginService.login(username, password); 
      if(token.access_token){
        localStorage.setItem("token", token.access_token);

        let passwordSegurity = getPasswordSegurity(password);
        let segurity = passwordSegurity.split('||');
        if(segurity[0] == 'true'){
          this.toastr.errorToastr(segurity[1], '', {enableHTML: true});
        }

        let user = await this._loginService.LoadActualUser();
        localStorage.setItem("user", JSON.stringify(user));

        let permissions = await this.permissions.loadPermissions(user);
        localStorage.setItem('permissions', JSON.stringify(permissions));

        this.router.navigate(['/principal']);
        this.loading = false;
      }
    } catch (e) {
      this.toastr.infoToastr(e.error.message, '', {enableHTML: true});
      this.loading = false;
    }
  }

  Toggle(){
    let temp = (<HTMLInputElement>document.getElementById('password'));
    temp.type = (temp.type === "password") ? "text" : "password";
  }

}
